import styled from 'styled-components'
import Typography from '../Typography'
import { colors } from '../Colors'

export const AIBeforeApplyTypo = styled(Typography)`
    span {
        font-weight: 500;
    }
`

export const AIBeforeApplyContainer = styled.div`
    padding: 16px;
    ul.list {
        list-style: none;
        padding: 0;
        margin: 0;
        li {
            display: flex;
            align-items: center;
            margin-bottom: 16px;
            svg {
                margin-right: 8px;
            }
        }
    }
`

export const ImageWrapper = styled.div`
    text-align: center;
    margin-bottom: 16px;
`

export const ListWrapper = styled.div`
    padding: 16px 24px;
`

export const CTAWrapper = styled.div`
    padding: 24px;
    border-top: 1px solid ${colors.grey[95]};
`
